import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, Leaf, Gauge, Layers } from 'lucide-react';
import { Button } from './Button';
const SYSTEM_IMG = 'https://cdn.magicpatterns.com/uploads/bLAPft22QjCpXe4u5EQJGb/tulsa-system.jpg';
const FEATURES = [{
  icon: Cpu,
  title: 'Modern Ceramic Valve',
  desc: 'Ceramic discs for a longer life, reduced maintenance, and 72-hour memory backup.'
}, {
  icon: Leaf,
  title: 'Coconut Shell Carbon',
  desc: 'Sustainably sourced carbon treats chlorine, chloramine, and harmful contaminants.'
}, {
  icon: Gauge,
  title: 'High-Capacity Resin',
  desc: 'USA-made 10% crosslinked resin removes hardness and lasts significantly longer.'
}, {
  icon: Layers,
  title: 'Polishing Gravel',
  desc: 'Enhanced filtration prevents channeling and ensures even water distribution.'
}];
const SPECS = [['System Flow Rate', '27 GPM'], ['Softening Capacity', '48,000 grains'], ['Carbon Volume', '15 lbs'], ['Media Tank', '10" × 54"']];
export function SystemSpotlight() {
  return <section className="bg-white py-20 sm:py-24" data-id="element-188" data-mp="jmz17wcfdbiz">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2" data-id="element-189" data-mp="jpk3gmgmxth9">
        <motion.div initial={{
        opacity: 0,
        x: -24
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="relative order-2 lg:order-1" data-id="element-190" data-mp="fo86twzcg7zk">
          <div className="overflow-hidden rounded-3xl border border-slate-200 bg-navy-900 shadow-xl" data-id="element-191" data-mp="12la5uashcrvo">
            <img src={SYSTEM_IMG} alt="Detailed breakdown of the Tulsa Water Pros complete home softener and filtration system" className="w-full object-cover" data-id="element-192" data-mp="yk85trqqobsn" />
          </div>
          <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-193" data-mp="17febmqq0etv6">
            {SPECS.map(([label, value]) => <div key={label} className="rounded-2xl border border-slate-200 bg-slate-50 p-4" data-id="element-194" data-mp="1m87tujwo1o3j">
                <p className="font-heading text-xl font-extrabold text-brand-blue" data-id="element-195" data-mp="1h9o6cf2fc492">{value}</p>
                <p className="text-xs font-medium uppercase tracking-wide text-slate-500" data-id="element-196" data-mp="1ocme7ikxnr9e">{label}</p>
              </div>)}
          </div>
        </motion.div>

        <div className="order-1 lg:order-2" data-id="element-197" data-mp="1yc3hxugmjv2q">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-brand-blue" data-id="element-198" data-mp="233liwiindvnp">
            Complete Home System
          </p>
          <h2 className="font-heading text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl" data-id="element-199" data-mp="281n2r5nwdz08">
            The ultimate water upgrade for your entire home
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600" data-id="element-200" data-mp="2h2uut5ztm3lv">
            Featuring a patented ceramic valve — the only valve of its kind backed by a true
            manufacturer lifetime warranty. Enjoy softer skin, spotless dishes, and crisp,
            great-tasting water while protecting your appliances and plumbing.
          </p>

          <div className="mt-8 grid gap-5 sm:grid-cols-2" data-id="element-201" data-mp="rqj0rj0wgy1f">
            {FEATURES.map((f, i) => <motion.div key={f.title} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.45,
            delay: i * 0.08
          }} className="flex gap-3" data-id="element-202" data-mp="k70biv12c8ke" data-mpi={i}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-cyan/10 text-brand-blue" data-id="element-203" data-mp="133rrauhec5jp">
                  <f.icon className="h-5 w-5" data-id="element-204" data-mp="y4f4g9qiyyh4" />
                </span>
                <div data-id="element-205" data-mp="t5lp0brogxeb">
                  <h3 className="text-sm font-bold text-navy-900" data-id="element-206" data-mp="t52gtmrtxndh">{f.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-slate-600" data-id="element-207" data-mp="o6itpj1i25jj">{f.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <div className="mt-9" data-id="element-208" data-mp="3dx4dmcyajjj8">
            <Button as="a" href="#quote" variant="primary" data-id="element-209" data-mp="38wzu0e2368os">
              Upgrade My Home&apos;s Water
            </Button>
          </div>
        </div>
      </div>
    </section>;
}